import React from "react";
import SingleBar from "../Elements/SingleBar";
import BlockLayout from "./../Layout/BlockLayout";
import { Container, Row } from "react-bootstrap";
import ComponentHeader from "../Header/ComponentHeader";
import SingleBarSvg from "../Charts/SingleBarSvgLargeBubble";
import { secondaryColor, oppositeColor, mainColor } from "../../Util/Colors";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import { useInView } from "react-intersection-observer";
import {
  calculatePercentage,
  periodToComma,
  numberWithSpaces
} from "../../Helpers/CommonHelper";
import {
  FiguresWrapper,
  HeadingMunicipality
} from "../../Util/StyleProps";
import EmptySpace from "../Elements/EmptySpace";
import SvgLayout from "./../Layout/SvgLayout";
// rösta ska ha kommatecken
const ElectionContainer = props => {
  const { data, sweden, blockColor, scroll } = props;
  const [ref, inView, entry] = useInView({
    /* Optional options */

    threshold: 0.5,
    triggerOnce: true
  });

  let municipality1 = data[0];
  let municipality2 = data[1];

  const lastElectionYear = sweden.election
    ? sweden.election.year
    : "årtal ej tillgängligt";

  let swedenString = sweden
    ? ` I hela Sverige röstade  ${numberWithSpaces(
        periodToComma(sweden.election.electionvalue)
      )} procent i det senaste valet till riksdagen (${lastElectionYear}). `
    : "";

  let total = 100;
  if (municipality1 && municipality2) {
    total =
      Number(municipality1.electionvalue) + Number(municipality2.electionvalue);
  } else if (municipality1) {
    total = municipality1.electionvalue;
  } else if (municipality2) {
    total = municipality2.electionvalue;
  }

  let maxOffset =
    municipality1 && municipality2
      ? 100 -
        calculatePercentage(
          Math.min(
            Number(municipality1.electionvalue),
            Number(municipality2.electionvalue)
          ),
          total
        )
      : 100;

  // Accessibility
  const ariaLabel = municipality => {
    return municipality
      ? `I ${municipality.name} kommun röstade ${municipality.electionvalue} procent i det senaste valet till riksdagen (${municipality.year}).`
      : "";
  };
  const svgAriaLabel = municipality =>
    municipality
      ? `Det här stapeldiagramet visar hur många procent som röstade i det senaste valet i ${municipality.name} kommun.`
      : "";

  const height = 150;
  const width = 100;

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M16.09 72.0507C14.7777 72.0507 13.6483 71.5776 12.7016 70.6315C11.7555 69.6848 11.2825 68.5554 11.2825 67.2432V53.3398L21.6025 42.0132L24.2883 44.7307L15 54.904H65L56.1025 44.8848L58.8208 42.1665L68.7175 53.3398V67.2432C68.7175 68.5554 68.2444 69.6848 67.2983 70.6315C66.3516 71.5776 65.2222 72.0507 63.91 72.0507H16.09ZM36.8975 47.1473L24.93 35.1157C23.9383 34.124 23.4872 32.9968 23.5766 31.734C23.6666 30.4712 24.1902 29.3504 25.1475 28.3715L41.5958 11.9232C42.5191 10.9998 43.6377 10.5298 44.9516 10.5132C46.2661 10.4959 47.4019 10.9659 48.3591 11.9232L60.3591 23.9232C61.2819 24.8676 61.7519 25.9659 61.7691 27.2182C61.7864 28.4698 61.2714 29.6193 60.2241 30.6665L43.7433 47.1148C42.8205 48.0593 41.7019 48.5487 40.3875 48.5832C39.0736 48.617 37.9102 48.1384 36.8975 47.1473ZM57.1025 27.8465C57.2947 27.6754 57.3908 27.4348 57.3908 27.1248C57.3908 26.8148 57.2947 26.5637 57.1025 26.3715L45.7566 14.9932C45.5855 14.8226 45.3397 14.7373 45.0191 14.7373C44.6986 14.7373 44.4527 14.8226 44.2816 14.9932L28.1025 31.1732C27.9314 31.3654 27.8458 31.6165 27.8458 31.9265C27.8458 32.2359 27.9314 32.4762 28.1025 32.6473L39.4483 44.0257C39.6411 44.2179 39.8922 44.314 40.2016 44.314C40.5116 44.314 40.7522 44.2179 40.9233 44.0257L57.1025 27.8465Z" fill="#1F44FF"/>
        <path d="M36.8975 47.1473L24.93 35.1157C23.9383 34.124 23.4872 32.9968 23.5767 31.734C23.6667 30.4712 24.1903 29.3504 25.1475 28.3715L41.5958 11.9232C42.5192 10.9998 43.6378 10.5298 44.9517 10.5132C46.2661 10.4959 47.4019 10.9659 48.3592 11.9232L60.3591 23.9232C61.2819 24.8676 61.7519 25.9659 61.7691 27.2182C61.7864 28.4698 61.2714 29.6193 60.2241 30.6665L43.7433 47.1148C42.8205 48.0593 41.7019 48.5487 40.3875 48.5832C39.0736 48.617 37.9103 48.1384 36.8975 47.1473ZM57.1025 27.8465C57.2947 27.6754 57.3908 27.4348 57.3908 27.1248C57.3908 26.8148 57.2947 26.5637 57.1025 26.3715L45.7567 14.9932C45.5855 14.8226 45.3397 14.7373 45.0191 14.7373C44.6986 14.7373 44.4528 14.8226 44.2817 14.9932L28.1025 31.1732C27.9314 31.3654 27.8458 31.6165 27.8458 31.9265C27.8458 32.2359 27.9314 32.4762 28.1025 32.6473L39.4483 44.0257C39.6411 44.2179 39.8922 44.314 40.2017 44.314C40.5117 44.314 40.7522 44.2179 40.9233 44.0257L57.1025 27.8465Z" fill="#0F0865"/>
        </svg>
        <ComponentHeader
          heading={"Så många av oss röstar"}
          text={swedenString}
        />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <div style={{ width: "47%", display: "flex", flexDirection: "column", alignItems: "baseline",justifyContent: "flex-end", justifyContent: "space-between", minWidth: "47%" }}>
                  <HeadingMunicipality
                    marginBottom="24px"
                    aria-label={ariaLabel(municipality1)}
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <div style={{ maxWidth: "280px" , width: "100%" }}>
                  <SingleBar
                    color={mainColor}
                    height={`${(180 * Number(calculatePercentage(municipality1?.electionvalue || 0, total)) / 100) + 140}px`}
                    inView={inView && municipality1 && municipality1.electionvalue > 0}
                    value={municipality1 ? periodToComma(municipality1.electionvalue.toFixed(1)) + '%' : 0}
                    label="personer"
                    lineColor={mainColor}
                  />
                  <div style={{ fontSize: "16px", marginTop: "8px", fontFamily: "Inter", textAlign: "center" }}>{municipality1.amount} Senaste riksdagsvalet</div>
                </div>
                </div>
              ) : (
                <div> </div>
              )}
              {municipality2 ? (
               <div style={{ width: "47%", display: "flex", flexDirection: "column", alignItems: "baseline",justifyContent: "flex-end", justifyContent: "space-between", minWidth: "47%" }}>
                  <HeadingMunicipality
                    color={secondaryColor}
                    marginBottom="24px"
                    aria-label={ariaLabel(municipality2)}
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <div style={{ maxWidth: "280px" , width: "100%" }}>
                    <SingleBar
                      color={oppositeColor}
                      height={`${(180 * Number(calculatePercentage(municipality2?.electionvalue || 0, total)) / 100) + 140}px`}
                      inView={inView && municipality2 && municipality2.electionvalue > 0}
                      value={municipality2 ? periodToComma(municipality2.electionvalue.toFixed(1)) + '%' : 0}
                      label="personer"
                      lineColor={oppositeColor}
                    />
                    <div style={{ fontSize: "16px", marginTop: "8px", fontFamily: "Inter", textAlign: "center" }}>{municipality2.amount} Senaste riksdagsvalet</div>
                  </div>
                </div>
              ) : (
                <SvgLayout width="50%">
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

export default ElectionContainer;
